import { formatCurrency, StatusContainer } from '@servicetitan/financing-utils-shared';
import { ApprovedPlans } from './ApprovedPlans';
import ApprovedIllustration from '../../common/illustrations/checkmark-success.svg';
import { PrequalificationDecisionDataStore } from './PrequalificationDecisionDataStore';

export const Approved = () => {
    const { prequalDecisionData } = PrequalificationDecisionDataStore.useStore();

    const { approvedAmount } = prequalDecisionData ?? {};

    return (
        <StatusContainer
            headline="Congratulations! Your pre-qualification request was approved by GreenSky® Program."
            message={`You have been prequalified for up to ${formatCurrency(approvedAmount ?? 0)}. Your offer is valid for 30 days.`}
            image={ApprovedIllustration}
        >
            <ApprovedPlans />
        </StatusContainer>
    );
};
